// Force to replace Delivery date to Shipping date for Giftship App
// Temporary fix for Drip App

$(document).ready(function(){
  $('.gs__shadow-box .gs__buttons-wrapper').find("input.gs__delivery-date:text").attr("placeholder", "Shipping Date");

  setTimeout(function(){
    $('.drip-form-aside > img:not([alt])').attr("alt", "Tasty Ribbon products with a box");
    $(".drip-form-main form input[type = 'email']").after( "<label for='drip-email-field-164592' class='sr-only'>Email</label>" );
  },100);
});
$(window).on('load', function(){

  $('.gs__shadow-box .gs__buttons-wrapper').find("input.gs__delivery-date:text").attr("placeholder", "Shipping Date");
  $('.gs__modal-body').find("input.gs__delivery-date:text").attr("placeholder", "Shipping Date");
  $('.gs__modal-body').find("label[for='gsDeliveryDate']").text("Shipping Date");
  $('.gs__field-input-wrapper').find("input#gsDeliveryDate").attr("name", "properties[Shipping Date]");

  var $multiShip = $('.gs__shadow-box');
  if ( $multiShip.length > 0){

    // The node to be monitored
    var target = $( "#gsGroupsBox" )[0];

    // Create an observer instance
    var observer = new MutationObserver(function( mutations ) {
      mutations.forEach(function( mutation ) {
        var newNodes = mutation.addedNodes; // DOM NodeList
        if( newNodes !== null ) { // If there are new nodes added
          var $nodes = $( newNodes ); // jQuery set
          $nodes.each(function() {
            var $node = $( this );

            $('.gs__shadow-box .gs__buttons-wrapper').find("input.gs__delivery-date:text").attr("placeholder", "Shipping Date");
            $('.gs__shadow-box .gs__buttons-wrapper').find("input.gs__delivery-date:text").attr("name", "shipping_date");
            $('.gs__field-input-wrapper').find("input#gsDeliveryDate").attr("name", "properties[Shipping Date]");

          });
        }
      });
    });
      // Configuration of the observer:
      var config = {
        attributes: true,
        childList: true,
        characterData: true
      };

      // Pass in the target node, as well as the observer options
      observer.observe(target, config);
  }

});

// Remove edit message for bundles on Gift Ship app cart page
document.addEventListener("DOMContentLoaded", function() {
    // Select all <a> elements with the attribute 'data-product-title'
    document.querySelectorAll('a[data-product-title]').forEach(function(element) {
        // Check if the 'data-product-title' attribute contains the word 'Bundle'
        if (element.getAttribute('data-product-title').includes('Bundle')) {
            // Hide the element by setting display to none
            element.style.display = 'none';
        }
    });
});

// Native collection filters accordion (supports h5.toggle headings)
(function ($) {
  function syncCollectionFilterToggles() {
    $('.collection-filters__group-title').each(function (index) {
      var $title = $(this);
      var $panel = $title.next('.toggle_list');

      if (!$panel.length) return;

      if (!$panel.attr('id')) {
        $panel.attr('id', 'collection-filters-panel-' + index);
      }

      $title.attr({
        role: 'button',
        tabindex: '0',
        'aria-controls': $panel.attr('id'),
        'aria-expanded': $panel.is(':visible') ? 'true' : 'false'
      });
    });
  }

  $(document).on('click.collectionFilters', '.collection-filters__group-title', function (event) {
    event.preventDefault();

    var $title = $(this);
    var $panel = $title.next('.toggle_list');

    if (!$panel.length) return;

    var shouldOpen = !$panel.is(':visible');
    $title.toggleClass('active', shouldOpen).attr('aria-expanded', shouldOpen ? 'true' : 'false');
    $panel.stop(true, true).slideToggle(180);
  });

  $(document).on('keydown.collectionFilters', '.collection-filters__group-title', function (event) {
    var key = event.key || event.keyCode;

    if (key === 'Enter' || key === ' ' || key === 13 || key === 32) {
      event.preventDefault();
      $(this).trigger('click');
    }
  });

  $(function () {
    syncCollectionFilterToggles();
  });

  $(document).on('shopify:section:load', function () {
    syncCollectionFilterToggles();
  });
})(jQuery);